import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=05885836&scoped=true&"
import script from "./sideNav.vue?vue&type=script&lang=ts&"
export * from "./sideNav.vue?vue&type=script&lang=ts&"
import style0 from "./sideNav.vue?vue&type=style&index=0&id=05885836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05885836",
  null
  
)

component.options.__file = "sideNav.vue"
export default component.exports